var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1bee27749f042b636e28a57d623764db.svg#b';
                    var viewUrl = 'sprites.1bee27749f042b636e28a57d623764db.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };